<div class="teaser-card">
  <div class="teaser-card-header ui-heading-4-bold">
    {{ title() }}
  </div>
  <div class="teaser-card-content ui-body-l mb-4">
    {{ description() }}
  </div>
  <div class="teaser-card-footer">
    @if (primaryBtn()) {
      <button
        rds-primary-button
        size="l"
        [attr.aria-label]="primaryBtn()"
        (click)="openExternal(primaryBtn()!)"
      >
        {{ BUTTONS.GET_STARTED }}
      </button>
    }
    @if (secondaryBtn()) {
      <button
        rds-secondary-button
        size="l"
        [attr.aria-label]="secondaryBtn()"
        (click)="openExternal(secondaryBtn()!)"
      >
        {{ BUTTONS.GET_STARTED }}
      </button>
    }
  </div>
</div>
